import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Skeleton, Popconfirm, Card, Avatar } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  deletePost,
  loadMoreCreativeStation,
} from "../../actions/creative-station-actions/actions";
import { ImgItem } from "./ImgItem";
import VideoComponent from "./VideoComponent";
import { DeleteOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import avatar_placeholder from "../../img/pdf_placeholder.png";
import Meta from "antd/lib/card/Meta";
import { EyeOutlined } from "@ant-design/icons";
import placeholder_jeans from "../../img/placeholder_jeans.svg";
import { color } from "html2canvas/dist/types/css/types/color";

interface Props {
  data: object[];
  title: string;
  isLoading: boolean;
}

export const MasonryBlock = ({ data, title, isLoading }: Props) => {
  const { next_page_newest, next_page_trending, next_page_moodboars } =
    useSelector((state: any) => state.posts);
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  return (
    <div className="masnory_block">
      <header>
        <h1 className="h1_title" style={{ whiteSpace: "nowrap" }}>
          {title}
        </h1>
        <div className="blue_line"></div>
      </header>

      <main
        className={
          title === "TRENDING" || title === "MOODBOARDS"
            ? //</div> ? "trending_masnory"
              "row"
            : "row"
        }
      >
        {isLoading
          ? Array.from(
              {
                length: title === "TRENDING" || title === "MOODBOARDS" ? 3 : 4,
              },
              (_, index) => index + 1
            ).map((_, i) => (
              <div
                className={
                  title === "TRENDING" || title === "MOODBOARDS"
                    ? "col-6"
                    : "col-12"
                }
                key={i}
              >
                <div className="d-flex flex-column">
                  <Skeleton.Avatar active={true} shape={"square"} />
                  <Skeleton active={true} title={true} />
                </div>
              </div>
            ))
          : data &&
            data.map((el: any) =>
              el.type === "video" ? (
                <>
                  {/* <div
                    className="box masonry_item_with_description"
                    key={uuidv4()}
                  >
                    <div style={{ position: "relative" }}>
                      {user &&
                        isAdmin &&
                        user.permissions.includes(
                          "creative-station.delete"
                        ) && (
                          <Popconfirm
                            placement="top"
                            title={"Are you sure you want to delete this post?"}
                            onConfirm={(e: any) => {
                              e.stopPropagation();
                              dispatch(deletePost(el.id, el.category));
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              className="delete_post_small_btn"
                              style={{ right: 15 }}
                            >
                              <DeleteOutlined
                                style={{
                                  color: "white",
                                  verticalAlign: 0,
                                }}
                              />
                            </button>
                          </Popconfirm>
                        )}
                      <VideoComponent post={el} />
                    </div>
                    {el.short_description && (
                      <Link
                        to={`/single-post/${el.id}`}
                        key={el.id}
                        className="video_card_link"
                      >
                        <div
                          className="masonry_item_description"
                          dangerouslySetInnerHTML={{
                            __html: `
                          <p><span class="item_title">${
                            el.name
                          } </span><br/> <span className="text-muted" style="font-size: 13px;">${moment(
                              el.created_at
                            ).format("DD/MM/YYYY")}</span>${
                              el.short_description
                            }</p>
                          `,
                          }}
                        />
                      </Link>
                    )}
                  </div> */}
                  <Card
                    key={uuidv4()}
                    style={{
                      width: 400,
                      margin: "25px",
                    }}
                    className="box2"
                    cover={
                      <div>
                        <div>
                          {" "}
                          <a
                            href={`/single-post/${el.id}`}
                            key={el.id}
                            className={
                              isAdmin
                                ? "delete_post_small_btn marginR"
                                : "delete_post_small_btn"
                            }
                            style={{ padding: "2px" }}
                          >
                            {" "}
                            <EyeOutlined
                              style={{
                                fontSize: "20px",
                                verticalAlign: 0,
                                color: "white",
                              }}
                            />
                          </a>
                        </div>
                        {user &&
                          isAdmin &&
                          user.permissions.includes(
                            "creative-station.delete"
                          ) && (
                            <Popconfirm
                              placement="top"
                              title={
                                "Are you sure you want to delete this post?"
                              }
                              onConfirm={(e: any) => {
                                e.stopPropagation();
                                dispatch(deletePost(el.id, el.category));
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <button
                                className="delete_post_small_btn"
                                style={{ right: 15, padding: "2px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "white",
                                    verticalAlign: 0,
                                    fontSize: "20px",
                                  }}
                                />
                              </button>
                            </Popconfirm>
                          )}
                        <VideoComponent post={el} />
                      </div>
                    }
                  >
                    <Meta
                      title={
                        el.short_description && (
                          <div
                            className="masonry_item_description"
                            /*           dangerouslySetInnerHTML={{
                                __html: `
                                  <p><span class="item_title" style="font-size: 19px;color:red">${
                                    el.name
                                  } </span><br/> <span className="text-muted" style="font-size: 13px;">${moment(
                                  el.created_at
                                ).format("DD/MM/YYYY")}</span><span 
                               style="font-size: 19px; color:red">${
                                 el.short_description
                               }</span></p>
                                `,
                              }} */
                          >
                            <span>{el.name}</span>
                            <br />{" "}
                            <span className="text-muted">
                              {/*    {moment(el.updated_at).format("DD/MM/YYYY")} */}
                              {el.session}
                            </span>
                          </div>
                        )
                      }
                    />
                  </Card>
                </>
              ) : el.type === "article" ? (
                /*    <a
                  href={`/single-post/${el.id}`}
                  key={el.id}
                  className="box2 masonry_item_with_description"
                  style={{ position: "relative" }}
                >
                  {user &&
                    isAdmin &&
                    user.permissions.includes("creative-station.delete") && (
                      <Popconfirm
                        placement="top"
                        title={"Are you sure you want to delete this post?"}
                        onConfirm={(e: any) => {
                          e.stopPropagation();
                          dispatch(deletePost(el.id, el.category));
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <button className="delete_post_small_btn">
                          <DeleteOutlined
                            style={{
                              color: "white",
                              verticalAlign: 0,
                            }}
                          />
                        </button>
                      </Popconfirm>
                    )}

                  {el.file.split(".")[1] == "pdf" ? (
                    <img src={avatar_placeholder} />
                  ) : (
                    <ImgItem
                      src={process.env.REACT_APP_STORAGE_URL + el.file}
                    />
                  )}

                  {el.short_description && (
                    <div
                      className="masonry_item_description"
                      dangerouslySetInnerHTML={{
                        __html: `
                        <p><span class="item_title">${
                          el.name
                        } </span> <br/> <span className="text-muted" style="font-size: 13px;">${moment(
                          el.created_at
                        ).format("DD/MM/YYYY")}</span> ${
                          el.short_description
                        }</p>
                        `,
                      }}
                    />
                  )}
                </a> */
                <>
                  <Card
                    style={{ width: 400, margin: "25px" }}
                    className="box2"
                    cover={
                      <>
                        <div>
                          {" "}
                          <a
                            href={`/single-post/${el.id}`}
                            key={el.id}
                            className={
                              isAdmin
                                ? "delete_post_small_btn marginR"
                                : "delete_post_small_btn"
                            }
                            style={{ padding: "2px" }}
                          >
                            {" "}
                            <EyeOutlined
                              style={{
                                fontSize: "20px",
                                verticalAlign: 0,
                                color: "white",
                              }}
                            />
                          </a>
                        </div>
                        <div>
                          {user &&
                            isAdmin &&
                            user.permissions.includes(
                              "creative-station.delete"
                            ) && (
                              <Popconfirm
                                placement="top"
                                title={
                                  "Are you sure you want to delete this post?"
                                }
                                onConfirm={(e: any) => {
                                  e.stopPropagation();
                                  dispatch(deletePost(el.id, el.category));
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <button
                                  className="delete_post_small_btn"
                                  style={{ right: 15, padding: "2px" }}
                                >
                                  <DeleteOutlined
                                    style={{
                                      color: "white",
                                      verticalAlign: 0,
                                      fontSize: "20px",
                                    }}
                                  />
                                </button>
                              </Popconfirm>
                            )}

                          {el.file.split(".")[1] == "pdf" ? (
                            <img
                              src={
                                el.file
                                  ? process.env.REACT_APP_STORAGE_URL + el.cover
                                  : avatar_placeholder
                              }
                              className="imgCover"
                            />
                          ) : (
                            <img
                              src={
                                el.file
                                  ? process.env.REACT_APP_STORAGE_URL + el.file
                                  : placeholder_jeans
                              }
                              className={
                                title === "TRENDING" ? "imgCover2" : "imgCover"
                              }
                            />
                          )}
                        </div>
                      </>
                    }
                  >
                    <Meta
                      title={
                        el.name && (
                          <div className="masonry_item_description">
                            <span>{el.name} </span>
                            <br />{" "}
                            <span className="text-muted">
                              {/*                               {moment(el.updated_at).format("DD/MM/YYYY")}
                               */}{" "}
                              {el.session}
                            </span>
                          </div>
                        )
                      }
                    />
                  </Card>
                </>
              ) : (
                el.type === "image" && (
                  /*       <a
                    className="box2 masonry_item_with_description"
                    key={uuidv4()}
                  >
                    <div style={{ position: "relative" }}>
                      {user &&
                        isAdmin &&
                        user.permissions.includes(
                          "creative-station.delete"
                        ) && (
                          <Popconfirm
                            placement="top"
                            title={"Are you sure you want to delete this post?"}
                            onConfirm={(e: any) => {
                              e.stopPropagation();
                              dispatch(deletePost(el.id, el.category));
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <button
                              className="delete_post_small_btn"
                              style={{ right: 15 }}
                            >
                              <DeleteOutlined
                                style={{
                                  color: "white",
                                  verticalAlign: 0,
                                }}
                              />
                            </button>
                          </Popconfirm>
                        )}
                      <ImgItem
                        src={process.env.REACT_APP_STORAGE_URL + el.file}
                      />
                    </div>
                    {el.short_description && (
                      <Link
                        to={`/single-post/${el.id}`}
                        key={el.id}
                        className="video_card_link"
                      >
                        <div
                          className="masonry_item_description"
                          dangerouslySetInnerHTML={{
                            __html: `
                          <p><span class="item_title">${
                            el.name
                          } </span><br/> <span className="text-muted" style="font-size: 13px;">${moment(
                              el.created_at
                            ).format("DD/MM/YYYY")}</span>${
                              el.short_description
                            }</p>
                          `,
                          }}
                        />
                      </Link>
                    )}
                  </a> */
                  <Card
                    style={{ width: 400, margin: "25px" }}
                    className="box2"
                    cover={
                      <div>
                        <div>
                          {" "}
                          <a
                            href={`/single-post/${el.id}`}
                            key={el.id}
                            className={
                              isAdmin
                                ? "delete_post_small_btn marginR"
                                : "delete_post_small_btn"
                            }
                            style={{ padding: "2px" }}
                          >
                            {" "}
                            <EyeOutlined
                              style={{
                                fontSize: "20px",
                                verticalAlign: 0,
                                color: "white",
                              }}
                            />
                          </a>
                        </div>
                        {user &&
                          isAdmin &&
                          user.permissions.includes(
                            "creative-station.delete"
                          ) && (
                            <Popconfirm
                              placement="top"
                              title={
                                "Are you sure you want to delete this post?"
                              }
                              onConfirm={(e: any) => {
                                e.stopPropagation();
                                dispatch(deletePost(el.id, el.category));
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <button
                                className="delete_post_small_btn"
                                style={{ right: 15, padding: "2px" }}
                              >
                                <DeleteOutlined
                                  style={{
                                    color: "white",
                                    verticalAlign: 0,
                                    fontSize: "20px",
                                  }}
                                />
                              </button>
                            </Popconfirm>
                          )}
                        <img
                          src={
                            el.file
                              ? process.env.REACT_APP_STORAGE_URL + el.file
                              : placeholder_jeans
                          }
                          className={
                            title === "TRENDING" ? "imgCover2" : "imgCover"
                          }
                        />
                      </div>
                    }
                  >
                    <Meta
                      title={
                        el.name && (
                          <div className="masonry_item_description">
                            <span> {el.name} </span>
                            <br />{" "}
                            <span className="text-muted">
                              {el.session}
                              {/*                               {moment(el.updated_at).format("DD/MM/YYYY")}
                               */}{" "}
                            </span>
                          </div>
                        )
                      }
                    />
                  </Card>
                )
              )
            )}
      </main>
      {title === "newest" && next_page_newest && (
        <button
          className="see_more_btn_masnoary"
          onClick={() => {
            dispatch(
              loadMoreCreativeStation(
                next_page_newest + "&draft=false",
                "newest"
              )
            );
          }}
        >
          See More <FontAwesomeIcon icon={faArrowDown} className="ml-2" />
        </button>
      )}
      {title === "moodboars" && next_page_moodboars && (
        <button
          className="see_more_btn_masnoary"
          onClick={() => {
            dispatch(loadMoreCreativeStation(next_page_moodboars, "moodboars"));
          }}
        >
          See More <FontAwesomeIcon icon={faArrowDown} className="ml-2" />
        </button>
      )}
      {title === "trending" && next_page_trending && (
        <button
          className="see_more_btn_masnoary"
          onClick={() => {
            dispatch(loadMoreCreativeStation(next_page_trending, "trending"));
          }}
        >
          See More <FontAwesomeIcon icon={faArrowDown} className="ml-2" />
        </button>
      )}
    </div>
  );
};
